import React, { useState } from 'react';
import { Provider } from 'react-redux';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import "../App.css";

// zippedi tools js imports
import { ReduxLoginWeb as PrivateRoute } from '@zippeditoolsjs/web';
import { lightTheme, darkTheme } from '@zippeditoolsjs/web';
import { ZtoolSnackAlert as SnackAlert } from '@zippeditoolsjs/blocks'

import Home from './redux/containers/home/Home';
import Search from './redux/containers/search/Search';
import Layout from './components/navbar/Layout';

// instantiate services and wire up dependencies
import createStore from 'core/store';
import HTTPService from 'core/services/http';
import DataSource from 'core/services/dataSource';
import AuthSource from 'core/services/authSource';

import { useTranslation, withTranslation } from 'react-i18next';

const { REACT_APP_API_BASE_URL, REACT_APP_AUTH_BASE_URL, REACT_APP_BASE_URL, REACT_APP_AUTH_BACKEND_URL } = process.env;

const http = new HTTPService();

const dataSource = new DataSource({
  baseUrl: REACT_APP_API_BASE_URL,
  http,
});

const authSource = new AuthSource({
  baseUrl: REACT_APP_AUTH_BACKEND_URL,
  http,
});

const store = createStore({
  authSource,
  dataSource,
});

const App = () => {
  const [theme, setTheme] = useState("light");
  const isDarkTheme = theme === "dark";
  const toggleTheme = () => setTheme(isDarkTheme ? "light" : "dark");

  const { i18n } = useTranslation();
  const toogleTranslation = (lang) => i18n.changeLanguage(lang);

  return (
    <Provider store={store}>
      <ThemeProvider theme={isDarkTheme ? darkTheme : lightTheme}>
        <SnackAlert />
        <PrivateRoute
          appUrlLogin={REACT_APP_AUTH_BASE_URL}
          appBaseUrl={REACT_APP_BASE_URL}
        >
          <Layout
            isDarkTheme={isDarkTheme}
            toggleTheme={toggleTheme}
            toogleTranslation={toogleTranslation}
          >
            <Router>
              <Routes>
                <Route exact path="/" element={<Home />} />
                <Route exact path="/search" element={<Search />} />
              </Routes>
            </Router>
          </Layout>
        </PrivateRoute>
      </ThemeProvider>
    </Provider>
  );
};

export default withTranslation()(App);
